/**
 * Collection Page – Madeleines Chaeslade
 * Handles: filter dropdowns, mobile bottom sheet, AJAX add to cart
 */
(function() {
  'use strict';

  // ============================================
  // FILTER DROPDOWNS
  // ============================================
  function initFilterDropdowns() {
    var dropdowns = document.querySelectorAll('.mc-filter-dropdown');
    dropdowns.forEach(function(dropdown) {
      var btn = dropdown.querySelector('.mc-filter-btn');
      if (!btn) return;
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var wasOpen = dropdown.classList.contains('open');
        closeAllDropdowns();
        if (!wasOpen) {
          dropdown.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
      var panel = dropdown.querySelector('.mc-filter-panel');
      if (panel) panel.addEventListener('click', function(e) { e.stopPropagation(); });
    });
    document.addEventListener('click', closeAllDropdowns);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeAllDropdowns(); });
  }
  function closeAllDropdowns() {
    document.querySelectorAll('.mc-filter-dropdown.open').forEach(function(d) {
      d.classList.remove('open');
      var btn = d.querySelector('.mc-filter-btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  // ============================================
  // FILTER CHECKBOX STATE
  // ============================================
  function initFilterCheckboxes() {
    document.querySelectorAll('.mc-filter-option input[type="checkbox"]').forEach(function(cb) {
      cb.addEventListener('change', function() {
        var label = this.closest('.mc-filter-option');
        if (label) label.classList.toggle('mc-filter-option--selected', this.checked);
      });
    });
  }

  // ============================================
  // MOBILE BOTTOM SHEET
  // ============================================
  function initBottomSheet() {
    var overlay = document.getElementById('mc-bottom-sheet-overlay');
    var trigger = document.getElementById('mc-mobile-filter-trigger');
    var closeBtn = document.getElementById('mc-bottom-sheet-close');
    if (!overlay) return;
    if (trigger) trigger.addEventListener('click', function() { overlay.classList.add('open'); document.body.style.overflow = 'hidden'; });
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeSheet(); });
    function closeSheet() { overlay.classList.remove('open'); document.body.style.overflow = ''; }
    document.querySelectorAll('.mc-bottom-sheet__chip input[type="checkbox"]').forEach(function(cb) {
      cb.addEventListener('change', function() {
        var chip = this.closest('.mc-bottom-sheet__chip');
        if (chip) chip.classList.toggle('mc-bottom-sheet__chip--selected', this.checked);
      });
    });
  }

  // ============================================
  // AJAX ADD TO CART (v12 — regex fix)
  // ============================================
  window.mcOpenCartDrawer = function() {
    var dialog = document.querySelector('cart-drawer-component dialog.cart-drawer__dialog');
    if (dialog && dialog.hasAttribute('open')) return;
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (e) {}
    }
    if (dialog && typeof dialog.showModal === 'function') {
      try { dialog.showModal(); } catch (e) {}
    }
  };

  function mcDrawerSectionId() {
    var host = document.querySelector('[data-mc-cart-root]');
    if (host) {
      var sid = host.getAttribute('data-section-id');
      if (sid) return sid;
      var parent = host.closest('[data-section-id]');
      if (parent) return parent.getAttribute('data-section-id');
    }
    return null;
  }

  function mcShowCartBubble(show) {
    document.querySelectorAll('.cart-bubble').forEach(function(c) {
      if (show) {
        c.removeAttribute('hidden');
        c.classList.remove('visually-hidden');
      } else {
        c.classList.add('visually-hidden');
      }
    });
  }

  /**
   * Surgical update: swap optimistic item with real item instantly.
   */
  function mcSurgicalUpdate(html, optimisticItem) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshRoot = doc.querySelector('[data-mc-cart-root]');
    var currentRoot = document.querySelector('[data-mc-cart-root]');
    if (!freshRoot || !currentRoot) return false;

    if (optimisticItem && optimisticItem.parentNode) {
      var freshItems = freshRoot.querySelectorAll('.mc-cart-item');
      if (freshItems.length > 0) {
        var newNode = document.importNode(freshItems[0], true);
        optimisticItem.parentNode.replaceChild(newNode, optimisticItem);
      }

      var freshFooter = freshRoot.querySelector('.mc-cart-footer');
      var currentFooter = currentRoot.querySelector('.mc-cart-footer');
      if (freshFooter && currentFooter) {
        currentFooter.innerHTML = freshFooter.innerHTML;
      } else if (freshFooter && !currentFooter) {
        currentRoot.appendChild(document.importNode(freshFooter, true));
      }

      var freshCount = freshRoot.querySelector('.mc-cart-count');
      var currentCount = currentRoot.querySelector('.mc-cart-count');
      if (freshCount && currentCount) currentCount.textContent = freshCount.textContent;

      return true;
    }

    currentRoot.innerHTML = freshRoot.innerHTML;
    var dialog = currentRoot.closest('dialog');
    if (dialog) dialog.setAttribute('data-mc-opened', '');
    return true;
  }

  function mcExtractCartCount(html) {
    if (html) {
      var match = html.match(/mc-cart-count[^>]*>(\d+)</);
      if (match) return parseInt(match[1], 10);
    }
    return null;
  }

  function mcUpdateCartBubble(count) {
    if (count === null || count === undefined) return;
    document.querySelectorAll('.cart-bubble__text, .cart-badge, .mc-cart-count').forEach(function(el) {
      el.textContent = count;
    });
    mcShowCartBubble(count > 0);
  }

  function mcEnsureCartItemsContainer() {
    var cartList = document.querySelector('.mc-cart-items');
    if (cartList) return cartList;

    var root = document.querySelector('[data-mc-cart-root]');
    if (!root) return null;

    var emptyMsg = root.querySelector('.mc-cart-empty');
    if (emptyMsg) emptyMsg.style.display = 'none';

    cartList = document.createElement('div');
    cartList.className = 'mc-cart-items';
    var header = root.querySelector('.cart-drawer__header');
    if (header && header.nextSibling) {
      root.insertBefore(cartList, header.nextSibling);
    } else {
      root.appendChild(cartList);
    }

    var footer = root.querySelector('.mc-cart-footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'mc-cart-footer';
      footer.innerHTML =
        '<div class="mc-cart-footer__total">' +
          '<span class="mc-cart-footer__total-label">Zwischensumme</span>' +
          '<span class="mc-cart-footer__total-value">CHF 0.00</span>' +
        '</div>' +
        '<div class="mc-cart-footer__tax-note">inkl. MwSt., zzgl. Versandkosten</div>' +
        '<a href="/checkout" class="mc-cart-footer__checkout">Zur Kasse</a>' +
        '<a href="/collections/alle-kasesorten" class="mc-cart-footer__continue">Weiter einkaufen</a>';
      root.appendChild(footer);
    }

    return cartList;
  }

  function mcInjectOptimisticItem(btn) {
    var card = btn ? btn.closest('.mc-product-card') : null;
    if (!card) return null;

    var img = card.querySelector('img');
    var name = card.querySelector('.mc-product-card__name');
    var priceEl = card.querySelector('.mc-product-card__price');
    var unitEl = card.querySelector('.mc-product-card__price-unit');

    var imgSrc = img ? img.getAttribute('src') : '';
    var prodName = name ? name.textContent.trim() : '';
    var priceText = priceEl ? priceEl.childNodes[0].textContent.trim() : '';
    var unitText = unitEl ? unitEl.textContent.trim() : '';

    // Build variant display text from unit (e.g. "/ 100 g" -> "100 g")
    var variantText = '';
    if (unitText) {
      variantText = unitText.replace(/^\/\s*/, '').trim();
    }

    var cartList = mcEnsureCartItemsContainer();
    if (!cartList) return null;

    var item = document.createElement('div');
    item.className = 'mc-cart-item mc-cart-item--optimistic';
    item.innerHTML =
      '<a class="mc-cart-item__image" style="pointer-events:none">' +
        (imgSrc ? '<img src="' + imgSrc + '" width="72" height="72" loading="eager" style="border-radius:8px;object-fit:cover" alt="">' : '') +
      '</a>' +
      '<div class="mc-cart-item__content">' +
        '<div class="mc-cart-item__title">' + prodName + '</div>' +
        (variantText ? '<div class="mc-cart-item__variant">' + variantText + '</div>' : '') +
        '<div class="mc-cart-item__price">' + priceText + '</div>' +
      '</div>' +
      '<div class="mc-cart-item__actions">' +
        '<div class="mc-cart-item__qty">' +
          '<button class="mc-qty-btn">−</button>' +
          '<input class="mc-qty-input" value="1" readonly style="width:28px;text-align:center;border:none;background:none">' +
          '<button class="mc-qty-btn">+</button>' +
        '</div>' +
        '<button class="mc-cart-item__remove" title="Entfernen">×</button>' +
      '</div>';

    cartList.insertBefore(item, cartList.firstChild);
    return item;
  }

  var mcAddBusy = false;

  window.mcAddToCart = function(variantId, triggerBtn) {
    if (!variantId || mcAddBusy) return;
    mcAddBusy = true;

    var btn = triggerBtn || document.querySelector('[data-variant-id="' + variantId + '"]');
    var orig = btn ? btn.innerHTML : '';

    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '✓ Hinzugefügt';
      btn.style.background = '#5A7247';
    }

    requestAnimationFrame(function() {
      document.querySelectorAll('.cart-bubble__text, .cart-badge, .mc-cart-count').forEach(function(el) {
        var n = parseInt(el.textContent, 10) || 0;
        el.textContent = n + 1;
      });
      mcShowCartBubble(true);

      var optimisticItem = mcInjectOptimisticItem(btn);

      if (window.mcOpenCartDrawer) window.mcOpenCartDrawer();

      var sid = mcDrawerSectionId();
      var body = { items: [{ id: variantId, quantity: 1 }] };
      if (sid) {
        body.sections = sid;
        body.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(e){ throw e; });
        return r.json();
      })
      .then(function(data) {
        var applied = false;
        if (sid && data && data.sections && data.sections[sid]) {
          var sectionHtml = data.sections[sid];
          var count = mcExtractCartCount(sectionHtml);
          applied = mcSurgicalUpdate(sectionHtml, optimisticItem);
          if (count !== null) mcUpdateCartBubble(count);
        }
        if (!applied) {
          if (optimisticItem && optimisticItem.parentNode) optimisticItem.parentNode.removeChild(optimisticItem);
          document.dispatchEvent(new CustomEvent('cart:add'));
        }
        document.dispatchEvent(new CustomEvent('mc-cart:updated'));
        setTimeout(function() {
          if (btn) { btn.disabled = false; btn.innerHTML = orig; btn.style.background = ''; }
          mcAddBusy = false;
        }, 900);
      })
      .catch(function(err) {
        console.error('[mc-cart] add failed', err);
        if (optimisticItem && optimisticItem.parentNode) optimisticItem.parentNode.removeChild(optimisticItem);
        document.querySelectorAll('.cart-bubble__text, .cart-badge, .mc-cart-count').forEach(function(el) {
          var n = parseInt(el.textContent, 10) || 0;
          if (n > 0) el.textContent = n - 1;
        });
        if (btn) { btn.disabled = false; btn.innerHTML = orig; btn.style.background = ''; }
        mcAddBusy = false;
      });
    });
  };

  // ============================================
  // PREVENT EMPTY PRICE PARAMS
  // ============================================
  function initFormCleanup() {
    var form = document.getElementById('mc-filter-form');
    if (!form) return;
    form.addEventListener('submit', function() {
      form.querySelectorAll('input[type="number"]').forEach(function(input) {
        if (input.value === '' || input.value === '0') input.removeAttribute('name');
      });
      form.querySelectorAll('input[type="checkbox"]:not(:checked)').forEach(function(cb) { cb.removeAttribute('name'); });
    });
  }

  // ============================================
  // INIT
  // ============================================
  function init() {
    initFilterDropdowns();
    initFilterCheckboxes();
    initBottomSheet();
    initFormCleanup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
